/* ============================================================
   CECIL CREEK FARM — JS Init
   File: assets/cecilcreek-init.js

   ADD TO layout/theme.liquid before </body>:
   {{ 'cecilcreek-init.js' | asset_url | script_tag }}
============================================================ */

(function () {
  'use strict';

  /* --- Scroll Reveal --- */
  function initReveal() {
    var els = document.querySelectorAll('.cc-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: make all visible immediately
      els.forEach(function (el) { el.classList.add('cc-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cc-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* --- Hero Slider --- */
  function initHeroSlider() {
    var wrap = document.querySelector('.cc-hero-slider');
    if (!wrap) return;

    var slides = wrap.querySelectorAll('.cc-hero-slide');
    if (slides.length <= 1) return;

    var current = 0;
    var interval = parseInt(wrap.getAttribute('data-interval') || '5000', 10);

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      slides[idx].classList.add('is-active');
      current = idx;
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    slides[0].classList.add('is-active');
    setInterval(next, interval);
  }

  /* --- Run on DOM ready --- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initHeroSlider();
    });
  } else {
    initReveal();
    initHeroSlider();
  }

})();
